
import { Component } from '@angular/core';


@Component({

    selector: 'invoice-cmp',
    templateUrl: './invoice.component.html',
    
   
  })
export class InvoiceComponent {}


// WEBPACK FOOTER //
// ./src/app/crm/kcc/invoice/invoice.component.ts